// @flow
import { createSelector } from 'reselect';
import getLeague from './getLeague';

export default createSelector(
	getLeague,
	({ status }) => status !== 'scheduled',
);


// WEBPACK FOOTER //
// ./src/modules/selectors/league/isLeagueStarted.js